export default __webpack_public_path__ + "static/media/H4006.ad64958e.mp3";